import { useInView } from 'react-intersection-observer';

interface ScrollAnimationOptions {
  threshold?: number;
  once?: boolean;
}

export function useScrollAnimation<T extends HTMLElement = HTMLDivElement>(options?: ScrollAnimationOptions) {
  const [ref, isInView] = useInView({
    threshold: options?.threshold ?? 0.2,
    triggerOnce: options?.once ?? true,
  });

  return { ref, isInView };
}
